import React from "react";
import {
  AppBar,
  Box,
  Button,
  Chip,
  Container,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Add, MenuRounded } from "@mui/icons-material";
import { Link as RouterLink, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Priority", to: "/favourite" },
  { label: "Calendar", to: "/calendar" },
  { label: "Completed", to: "/completed" },
  { label: "Celebrations", to: "/celebrations" },
  { label: "About", to: "/about" },
];

const drawerItems = navItems;

const navLinkStyles = ({ isActive }) => ({
  textDecoration: "none",
  color: isActive ? "#0f172a" : "#334155",
  backgroundColor: isActive ? "rgba(37, 99, 235, 0.12)" : "transparent",
  border: isActive ? "1px solid rgba(37, 99, 235, 0.18)" : "1px solid transparent",
  padding: "10px 14px",
  borderRadius: 999,
  fontSize: "0.92rem",
  fontWeight: isActive ? 700 : 600,
  transition: "all 180ms ease",
});

const Header = () => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          top: 0,
          bgcolor: "transparent",
          backdropFilter: "blur(18px)",
          borderBottom: "1px solid rgba(148, 163, 184, 0.18)",
          boxShadow: "none",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              minHeight: { xs: 76, md: 88 },
              gap: 2,
            }}
          >
            <Stack
              component={RouterLink}
              to="/"
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{
                textDecoration: "none",
                color: "text.primary",
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  width: 46,
                  height: 46,
                  borderRadius: 3,
                  overflow: "hidden",
                  bgcolor: "rgba(255,255,255,0.8)",
                  boxShadow: "0 16px 36px rgba(37, 99, 235, 0.25)",
                  border: "1px solid rgba(255,255,255,0.7)",
                }}
                component="img"
                src={`${process.env.PUBLIC_URL}/icons/logo512.png`}
                alt="VenTush logo"
              />
              <Box>
                <Typography variant="h5" sx={{ lineHeight: 1, mb: 0.3 }}>
                  VenTush
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Calm timeline for what matters
                </Typography>
              </Box>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              sx={{
                ml: "auto",
                display: { xs: "none", md: "flex" },
                p: 0.75,
                borderRadius: 999,
                bgcolor: alpha("#ffffff", 0.66),
                border: "1px solid rgba(255,255,255,0.7)",
              }}
            >
              {navItems.map((item) => (
                <NavLink key={item.to} to={item.to} style={navLinkStyles}>
                  {item.label}
                </NavLink>
              ))}
            </Stack>

            <Stack direction="row" spacing={1.25} alignItems="center">
              <Button
                component={RouterLink}
                to="/add"
                variant="contained"
                startIcon={<Add />}
                sx={{ display: { xs: "none", sm: "inline-flex" } }}
              >
                Add Date
              </Button>

              <IconButton
                onClick={() => setOpen(true)}
                sx={{
                  display: { xs: "inline-flex", md: "none" },
                  bgcolor: alpha("#ffffff", 0.8),
                  border: "1px solid rgba(255,255,255,0.8)",
                }}
              >
                <MenuRounded />
              </IconButton>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: 300,
            p: 2,
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(239,246,255,0.95))",
          },
        }}
      >
        <Stack spacing={1.2}>
          <Typography variant="h4" sx={{ px: 1, pt: 0.5 }}>
            Navigate
          </Typography>
          {drawerItems.map((item) => (
            <Button
              key={item.to}
              component={RouterLink}
              to={item.to}
              color={location.pathname === item.to ? "primary" : "inherit"}
              variant={location.pathname === item.to ? "contained" : "text"}
              sx={{ justifyContent: "flex-start" }}
            >
              {item.label}
            </Button>
          ))}
          <Button
            component={RouterLink}
            to="/add"
            variant="contained"
            startIcon={<Add />}
            sx={{ mt: 1 }}
          >
            Add Date
          </Button>
        </Stack>
      </Drawer>
    </>
  );
};

export default Header;
